module.exports = __webpack_public_path__ + "img/sahabat.89b435bb.webp";